// extracted by mini-css-extract-plugin
export default {"label":"src-components-GroupInfo-style__FpyDf__label","value":"src-components-GroupInfo-style__sbtoP__value"};